import request from "@/utils/request";
import { CommissionResponse, DailySummaryResponse, TransactionResponse } from "@/types/financialDetails";

export const fetchCommissionList = async (query: any, page_no: number, page_size: number): Promise<CommissionResponse> => {
    const res = await request.post<CommissionResponse>('/finance/commissions', { ...query, page_no, page_size });
    return {
        list: (res.list || []).map((item: any) => ({
            customerUID: item.customer_id, // customer_id
            remark: item.remark, // remark
            orderID: item.order_id, // order_id
            customerGroup: item.group_name, // group_name
            // associatedAgent: item.affiliated_agent_id, // affiliated_agent_id
            superiorAgentUID: item.superior_id, // superior_id
            tradingPair: item.contract_code, // contract_code
            rebateRate: item.rebate_rate, // rebate_rate
            rebateAmount: item.rebate_amount, // rebate_amount
            rebateTime: item.rebate_time, // rebate_time
            transactionMethod: item.trading_method, // trading_method
            depositStatus: item.commission_status, // commission_status
        })),
        total: res.total,
        total_commission: res.total_commission,
        spot_commission: res.spot_commission,
        contract_commission: res.contract_commission,
        alpha_commission: res.alpha_commission,
    };
};


export const fetchTransactionList = async (query: any, page_no: number, page_size: number): Promise<TransactionResponse> => {
    const res = await request.post<TransactionResponse>('/finance/transactions', { ...query, page_no, page_size });
    return {
        list: (res.list || []).map((item: any) => ({
            customerUID: item.customer_id, // customer_id
            remark: item.remark, // remark
            orderID: item.order_id, // order_id
            email: item.email, // email
            // handlingFee: item.handling_fee, // handling_fee
            group: item.group_name, // group_name
            superiorAgentUID: item.superior_id, // superior_id
            transactionTime: item.trade_time, // trade_time
            tradingPair: item.contract_code, // contract_code
            transactionVolume: item.trade_amount, // trade_amount
            netFee: item.commission, // commission
            transactionMethod: item.trade_method, // trade_method
            operationAmount: item.operation_amount // operation_amount
        })),
        total: res.total,
        total_trading_volume: res.total_trading_volume,
        spot_trading_volume: res.spot_trading_volume,
        contract_trading_volume: res.contract_trading_volume,
        alpha_trading_volume: res.alpha_trading_volume,
        total_handling_fees: res.total_handling_fees,
        spot_handling_fees: res.spot_handling_fees,
        contract_handling_fees: res.contract_handling_fees,
        alpha_handling_fees: res.alpha_handling_fees,
    };
};

export const fetchDailyList = async (query: any, page_no: number, page_size: number): Promise<DailySummaryResponse> => {
    const res = await request.post<DailySummaryResponse>('/finance/daily-summary', { ...query, page_no, page_size });
    return {
        list: (res.list || []).map((item: any) => ({
            date: item.date,
            totalCommission: item.commission,
            totalTransactionAmount: item.transaction_amount,
            netHandlingFee: item.gross_fee,
            newInvitedPeopleCount: item.registration_count,
        })),
        total: res.total,
    };
};

export const fetchContractCode = async (): Promise<any> => {
    const res = await request.post<any>('/common/contract/list');
    const arr = Array.isArray(res) ? res : Array.isArray(res.data?.data) ? res : [];
    return arr.map((item: any) => item.contract_code);
};

export const exportData = async (query: any, type: number): Promise<any> => {
    if (![1, 2, 3].includes(type)) {
        throw new Error('Invalid export type');
    }
    let param;
    if (type === 1) {
        // Commission export
        param = {
            type: type,
            commission_detail_arg: { ...query }
        };
    }
    if (type === 2) {
        // Transaction export
        param = {
            type: type,
            transaction_detail_arg: { ...query }
        };
    }
    if (type === 3) {
        // Daily summary export
        param = {
            type: type,
            daily_summary_arg: { ...query }
        };
    }

    const res = await request.post<any>('/finance/export', param);
    if (type === 1) {
        // Commission export
        return {
            list: (res.list || []).map((item: any) => ({
                customerUID: item.user_id,
                remark: item.remark,
                orderID: item.order_id,
                // customerGroup: item.group_name,
                associatedAgent: item.affiliated_agent_id,
                superiorAgentUID: item.superior_agent_id,
                tradingPair: item.contract_code,
                rebateRate: item.rebate_rate,
                rebateAmount: item.rebate_amount,
                rebateTime: item.rebate_time,
                transactionMethod: item.trading_method,
                depositStatus: item.commission_status,
            })),
            total: res.total,
            cumulativeCommission: res.total_commission,
            spotCommission: res.spot_commission,
            contractCommission: res.contract_commission,
        };
    } else if (type === 2) {
        // Transaction export
        return {
            list: (res.list || []).map((item: any) => ({
                customerUID: item.user_id,
                remark: item.remark,
                email: item.email,
                // handlingFee: item.handling_fee,
                // group: item.group_name,
                superiorAgentUID: item.superior_id,
                transactionTime: item.trade_time,
                tradingPair: item.contract_code,
                transactionVolume: item.trade_amount,
                netFee: item.commission,
                transactionMethod: item.trade_method,
                // operationAmount: item.operation_amount
            })),
            total: res.total,
            total_trading_volume: res.total_trading_volume,
            spot_trading_volume: res.spot_trading_volume,
            contract_trading_volume: res.contract_trading_volume,
            total_handling_fees: res.total_handling_fees,
            spot_handling_fees: res.spot_handling_fees,
            contract_handling_fees: res.contract_handling_fees,
        };
    } else {
        // Daily summary export
        return {
            list: (res.list || []).map((item: any) => ({
                date: item.date,
                totalCommission: item.commission,
                totalTransactionAmount: item.transaction_amount,
                netHandlingFee: item.gross_fee,
                newInvitedPeopleCount: item.registration_count,
            })),
            total: res.total,
        };
    }
};
